import { httpPost, httpGet, httpDownload } from '../../../../utils/api.utils';
import {
    DEFAULT_EXCEPTION_DETAILS, DEFAULT_TABLE_RESULT_MODEL, AUDITRULES_REPORT_HEADERS as auditrulesReportHeaders,
    AUDITRULES_REPORT_PROPS as auditrulesReportProps } from '../../../../constants/external-constants';
import { convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';
import {
    getInvoiceAuditRules,
    setInvoiceAuditRulesError,
    setInvoiceAuditRulesColSearchStr,
    setInvoiceAuditRulesPageSize,
    sortInvoiceAuditRules,
    resetInvoiceAuditRules,
    getAuditChartData,
    getInvoiceAuditRulesDetails,
    resetInvoiceAuditRulesDetails,
    getExceptionStatus,
    setExceptionStatus,
    setAdditionalInfo,
    saveExceptionData,
} from '../../../../constants/model-reducers/external/invoice/invoice/audit-table.settings';
 
const defaultState = () => ({
    isInvoiceAuditRulesLoaded: false,
    isInvoiceAuditRulesError: false,
    invoiceAuditRulesItems: DEFAULT_TABLE_RESULT_MODEL,
    invoiceAuditRulesIsSortedAsc: false,
    isInvoiceAuditRulesChartContentLoaded: false,
    IsSortAscending: false,
    auditChartItems: [],
    auditRulesExceptionDetails: DEFAULT_EXCEPTION_DETAILS,
    isInvoiceAuditRulesDetailsLoaded: false,
});

const initialState = defaultState();

export const invoiceAuditRulesActions = {
    getInvoiceAuditRules: (invoiceDetailsId, pageIndex) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, IsSortAscending,invoiceAuditRulesIsSortedAsc } = state().invoiceAuditRules.invoiceAuditRulesItems;
        var formData = {
            InvoiceID: invoiceDetailsId,
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: SortedColumnName,
            IsSortAscending: invoiceAuditRulesIsSortedAsc,
            TableFilterList: [],
        };
        var invoiceAuditRules = await httpPost('external/invoice/getInvoicesAuditRules', formData);
        if (invoiceAuditRules.ok === false) {
            dispatch({
                type: setInvoiceAuditRulesError,
                isInvoiceAuditRulesError: true,
                isInvoiceAuditRulesLoaded: false
            });
        } else {
            dispatch({
                type: getInvoiceAuditRules,
                invoiceAuditRulesItems: Object.keys(invoiceAuditRules).length > 0 ? invoiceAuditRules : DEFAULT_TABLE_RESULT_MODEL,
                isInvoiceAuditRulesLoaded: true,
                isInvoiceAuditRulesError: false
            });
        }
    },
    setInvoiceAuditRulesColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { invoiceAuditRulesItems } = state().invoiceAuditRules;
        var invoiceAuditRulesItemsUpd = {
            ...invoiceAuditRulesItems,
            "Headers": {
                ...invoiceAuditRulesItems.Headers,
                [key]: {

                    ...invoiceAuditRulesItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setInvoiceAuditRulesColSearchStr,
            data: invoiceAuditRulesItemsUpd,
            isInvoiceAuditRulesError: false,
            isInvoiceAuditRulesLoaded: true
        });
    },
    sortInvoiceAuditRules: (columnClicked, isSortedAsc, invoiceDetailsId) => async (dispatch, state) => {
        const { Headers, Pagination, Data, SortedColumnName, IsSortAscending, invoiceAuditRulesIsSortedAsc } = state().invoiceAuditRules.invoiceAuditRulesItems;
        const { invoiceAuditRulesItems } = state().invoiceAuditRules;
        var formData = {
            InvoiceID: invoiceDetailsId,
            PageFilter: {
                PageIndex: Pagination.PageNumber !== undefined ? Pagination.PageNumber : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...invoiceAuditRulesItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: [],
        };
        var invoiceAuditRules = await httpPost('external/invoice/getInvoicesAuditRules', formData);
        dispatch({
            type: sortInvoiceAuditRules,
            invoiceAuditRulesItems: invoiceAuditRules,
            invoiceAuditRulesIsSortedAsc: isSortedAsc,
            isInvoiceAuditRulesLoaded: true,
            isInvoiceAuditRulesError: false
        });
    },

    resizeAuditRulesPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setInvoiceAuditRulesPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractInvoiceAuditRules: (invoiceDetailsId) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, invoiceAuditRulesIsSortedAsc } = state().invoiceAuditRules.invoiceAuditRulesItems;
        const dealName = sessionStorage.getItem('DealName');      
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');   

        var filename = `ATEM ${dealName} Invoice Exception – ${formattedTimeZoneDate}`;

        var ExtractHeaders = {
            Headers: {
                InvoiceNum: {
                    propName: auditrulesReportProps.InvoiceNum,
                    hidden: false,
                    order: 1,
                    name: auditrulesReportHeaders.InvoiceNum
                },
                BilledCircuitId: {
                    propName: auditrulesReportProps.BilledCircuitId,
                    hidden: false,
                    order: 2,
                    name: auditrulesReportHeaders.BilledCircuitId
                },

                MatchedCircuitCode: {
                    propName: auditrulesReportProps.MatchedCircuitCode,
                    hidden: false,
                    order: 3,
                    name: auditrulesReportHeaders.MatchedCircuitCode
                },

                AuditRulesException: {
                    propName: auditrulesReportProps.AuditRulesException,
                    hidden: false,
                    order: 4,
                    name: auditrulesReportHeaders.AuditRulesException
                },

                AuditRulesResultsStatusName: {
                    propName: auditrulesReportProps.AuditRulesResultsStatusName,
                    hidden: false,
                    order: 5,
                    name: auditrulesReportHeaders.AuditRulesResultsStatusName
                },



                Datecreated: {
                    propName: auditrulesReportProps.DateCreated,
                    hidden: false,
                    order: 6,
                    name: auditrulesReportHeaders.DateCreated


                },

                CreatedBy: {
                    propName: auditrulesReportProps.CreatedBy,
                    hidden: false,
                    order: 7,
                    name: auditrulesReportHeaders.CreatedBy
                },


                DateModified: {
                    propName: auditrulesReportProps.DateModified,
                    hidden: false,
                    order: 8,
                    name: auditrulesReportHeaders.DateModified


                },

                ModifiedBy: {
                    propName: auditrulesReportProps.ModifiedBy,
                    hidden: false,
                    order: 9,
                    name: auditrulesReportHeaders.ModifiedBy
                },



                AdditionalInformation: {
                    propName: auditrulesReportProps.AdditionalInformation,
                    hidden: false,
                    order:10,
                    name: auditrulesReportHeaders.AdditionalInformation
                },




                DisputeCode: {
                    propName: auditrulesReportProps.DisputeCode,
                    hidden: false,
                    order: 11,
                    name: auditrulesReportHeaders.DisputeCode


                },


                DisputeStatus: {
                    propName: auditrulesReportProps.DisputeStatus,
                    hidden: false,
                    order: 12,
                    name: auditrulesReportHeaders.DisputeStatus


                },
              

            }
        }

        var data = {
            InvoiceID: invoiceDetailsId,
            PageFilter: {
                PageIndex: 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            },
            FileName: filename,
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...ExtractHeaders.Headers
            },
            SortedColumnName: SortedColumnName,
            IsSortAscending: invoiceAuditRulesIsSortedAsc,
            TableFilterList: [],
        };

        httpDownload('external/invoice/getInvoicesAuditRulesExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
    resetInvoiceAuditRules: () => (dispatch, state) => {
        dispatch({
            type: resetInvoiceAuditRules
        })
    },
    resetInvoiceAuditRulesDetails: () => (dispatch, state) => {
        dispatch({
            type: resetInvoiceAuditRulesDetails,
            auditRulesExceptionDetails: DEFAULT_EXCEPTION_DETAILS,
            isInvoiceAuditRulesDetailsLoaded: false,
        })
    },
    getAuditChartData: (invoiceDetailsId) => async (dispatch, state) => {
        var data = {
            InvoiceID: invoiceDetailsId,
        };

        var chartItems = await httpPost('external/invoice/getAuditGraphDataCount', data)

        dispatch({
            type: getAuditChartData,
            chartItems: Object.keys(chartItems).length > 0 ? chartItems : DEFAULT_TABLE_RESULT_MODEL,
            isInvoiceAuditRulesChartContentLoaded: true
        })
    },
    getInvoiceAuditRulesDetails: (invoiceDetailsId, auditDetailsId, exceptionId) => async (dispatch, state) => {

        var exceptionStatus = await getExceptionStatusDropdown();
        dispatch({ type: getExceptionStatus, data: exceptionStatus });
        var auditRulesDetails = await httpGet('external/invoice/getInvoicesExceptionDetails/' + invoiceDetailsId + '/' + auditDetailsId + '/' + exceptionId);
            dispatch({
                type: getInvoiceAuditRulesDetails,
                auditRulesExceptionDetails: Object.keys(auditRulesDetails).length > 0 ? auditRulesDetails : DEFAULT_EXCEPTION_DETAILS,
                isInvoiceAuditRulesDetailsLoaded: true,
            });

    },
    onChangeStatusSelect: (statusValue, auditDetailsId) => async (dispatch, state) => {

        var exceptionStatusValue = {
            ExceptionStatusID: statusValue,
            AuditDetailsID: auditDetailsId,
        };
        dispatch({ type: setExceptionStatus, data: exceptionStatusValue });

    },
    onChangeAdditionalInfoText: (value) => async (dispatch, state) => {

        var additionalInfoValue = {
            AdditionalInformation: value,
        };
        dispatch({ type: setAdditionalInfo, data: additionalInfoValue });

    },
    saveExceptionStatusData: (statusValue, additionalInfoValue, invoiceDetailsId, auditId) => async (dispatch, state) => {

        try {
            var exceptionStatusData = {
                InvoiceId: invoiceDetailsId,
                AuditResultId: auditId,
                ExceptionStatusId: statusValue,
                AdditionalInformation: additionalInfoValue,
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
            };
            var result = await httpPost('external/invoice/updateExceptionStatus/', exceptionStatusData);
            dispatch({
                type: saveExceptionData,
                data: result
            });
        }
        catch (ex) {
            return false;
        }

    },
};

async function getExceptionStatusDropdown() {
    try {
        var result = await httpGet('external/invoice/exception-status-dropdown');

        return result.data;
    }
    catch (e) {
        return [];
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceAuditRules:
            return {
                ...state,
                invoiceAuditRulesItems: action.invoiceAuditRulesItems,
                isInvoiceAuditRulesLoaded: action.isInvoiceAuditRulesLoaded,
                isInvoiceAuditRulesError: action.isInvoiceAuditRulesError
            };
        case setInvoiceAuditRulesError:
            return {
                ...state,
                isInvoiceAuditRulesError: action.isInvoiceAuditRulesError,
                isInvoiceAuditRulesLoaded: action.isInvoiceAuditRulesLoaded
            }
        case setInvoiceAuditRulesColSearchStr:
            return {
                ...state,
                invoiceAuditRulesItems: action.data,
                isInvoiceAuditRulesLoaded: action.isInvoiceAuditRulesLoaded,
                isInvoiceAuditRulesError: action.isInvoiceAuditRulesError
            }
        case setInvoiceAuditRulesPageSize:
            return {
                ...state,
                invoiceAuditRulesItems: {
                    ...state.invoiceAuditRulesItems,
                    Pagination: {
                        ...state.invoiceAuditRulesItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case sortInvoiceAuditRules:
            return {
                ...state,
                invoiceAuditRulesItems: action.invoiceAuditRulesItems,
                invoiceAuditRulesIsSortedAsc: action.invoiceAuditRulesIsSortedAsc,
                isInvoiceAuditRulesLoaded: action.isInvoiceAuditRulesLoaded
            }
        case resetInvoiceAuditRules:
            return initialState;
        case resetInvoiceAuditRulesDetails:
            return {
                ...state,
                auditRulesExceptionDetails: action.auditRulesExceptionDetails,
                isInvoiceAuditRulesDetailsLoaded: action.isInvoiceAuditRulesDetailsLoaded,
            }
        case getAuditChartData:
            return {
                ...state,
                auditChartItems: action.chartItems,
                isInvoiceAuditRulesChartContentLoaded: action.isInvoiceAuditRulesChartContentLoaded,
            }
        case getInvoiceAuditRulesDetails:
            return {
                ...state,
                auditRulesExceptionDetails: action.auditRulesExceptionDetails,
                isInvoiceAuditRulesDetailsLoaded: action.isInvoiceAuditRulesDetailsLoaded,
            }
        case getExceptionStatus:
            return {
                ...state,
                exceptionStatusList: action.data
            };
        case setExceptionStatus:
            return {
                ...state,
                exceptionStatusValue: action.data
            };
        case setAdditionalInfo:
            return {
                ...state,
                additionalInfoValue: action.data
            };
        case saveExceptionData:
            return {
                ...state,
                exceptionStatusData: action.data
            };
        default:
            return state;
    }
};